import { fetcher } from '@commenda/utils';
import type { CreateFlattenPDFUploadUrlRequest } from './types';

export async function createFlattenPDFUploadUrl(
  data: CreateFlattenPDFUploadUrlRequest
): Promise<Response | null> {
  try {
    const res = await fetcher(
      'document-processing-job/flatten-pdf/upload-url',
      {
        method: 'POST',
        body: data,
      }
    );

    return res;
  } catch (err) {
    console.error('Error creating flatten PDF upload URL:', err);
    return null;
  }
}
